export default "__VITE_ASSET__CX4ErKRb__"